import React, { useMemo } from "react";
import { ICatalystActionItemProgress } from "../../../../interfaces/Catalyst.interfaces";
import { CustomCardWithCharts } from "../../../../SharedComponents/CustomCardWithCharts";
import { CatalystTabTooltips } from "../../Common/HealthView.constants";

export interface ActionItemProgressProps {
  data?: ICatalystActionItemProgress[];
  isLoading?: boolean;
}

const PALETTE = [
  "#73AA24", "#D0B232", "#0078D4", "#D77440", "#8764B8",
  "#00B294", "#E74856", "#744DA9", "#018574", "#D83B01",
];

export const CatalystActionItemProgress: React.FC<ActionItemProgressProps> = ({
  data,
  isLoading = false,
}) => {
  const groupedData = useMemo(() => {
    if (!data || data.length === 0) return [];
    return data.map((item, idx) => ({
      name: item.aiProgress ?? "Unknown",
      value: item.workItemCount ?? 0,
      colour: PALETTE[idx % PALETTE.length],
    }));
  }, [data]);

  return (
    <CustomCardWithCharts
      loading={isLoading}
      metricFilters={{}}
      onDataPointClick={() => {}}
      onResetFilters={() => {}}
      options={{
        chartOptions: [
          {
            id: 1,
            field: "aiProgress",
            key: "catalyst-action-item-progress-donut",
            title: "Action Item (AI) Progress",
            tooltipDescription: CatalystTabTooltips.ActionItemOverall,
            type: "donut",
            groupedData,
          },
        ],
      }}
    />
  );
};
